module.exports = __webpack_public_path__ + "img/29.46ba9a8c.webp";